import "./styles.scss";

import { FlagIcon } from "react-flag-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { InputBase, MenuItem } from "@mui/material";

import { handleSelectColor } from "../../../../utils/utils";
import logoD4UPNG from "../../../../assets/images/logo_d4u.png";
import stopwatchPNG from "../../../../assets/images/stopwatch.png";
import { getLastLanguageOfFormStudent, getStudentDashboard } from "../../../../store/middleware";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": { marginTop: theme.spacing(5) },
  "& .MuiInputBase-input": {
    border: "none",
    padding: "0",
    margin: "0",
    height: "0",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}));

const CardStudent = ({ ratingPending }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);
  const { studentDashboardHeader } = useSelector((state) => state.studentReducer);

  const [lingoLanguageId, setLingoLanguageId] = useState(1);
  const [allowedLanguage, setAllowedLanguage] = useState([]);

  const levelDescription = {
    A0: t("NIVEL_A0"),
    A1: t("NIVEL_A1"),
    A2: t("NIVEL_A2"),
    B1: t("NIVEL_B1"),
    B2: t("NIVEL_B2"),
    C1: t("NIVEL_C1"),
    C2: t("NIVEL_C2"),
    DM: t("NIVEL_DM"),
  };

  const rangeColorsLevel = {
    A0: "rgb(0, 195, 140)",
    A1: "rgb(0, 151, 78)",
    A2: "rgb(97, 179, 50)",
    B1: "rgb(202, 221, 6)",
    B2: "rgb(255, 152, 0)",
    C1: "rgba(234, 112, 101, 1)",
    C2: "rgb(255, 23, 0)",
    DM: "rgb(255, 23, 0)",
    DEMO: "rgb(94, 23, 235)",
  };

  const levelProgressPercents = studentDashboardHeader?.progress?.level_progress_percent?.toFixed(0) ?? 0;

  const currentStudentLevel =
    studentDashboardHeader?.levelOfStudent?.length > 0 ? studentDashboardHeader?.levelOfStudent[0]?.level : "-";

  const currentStudentCycle =
    studentDashboardHeader?.levelOfStudent?.length > 0 && studentDashboardHeader?.levelOfStudent[0]?.contentCycle;

  const isInterview = plans && plans[0]?.studentPlanLanguages[0]?.lingoLanguage?.description === "Interview";

  const handleNavigateClassRating = () => navigate("/class-rating");

  const handleGetStudentDashboard = async (lingoLanguageId = 1) => {
    const payload = { type: "student", studentId: user?.studentId, lingoLanguageId };
    await dispatch(getStudentDashboard(payload));
  };

  const getData = async () => {
    if (location.pathname !== "/home") return;

    try {
      const newPlan = plans?.flatMap((item) => item.studentPlanLanguages.map((lang) => lang.lingoLanguage.id));
      setAllowedLanguage(newPlan);

      await dispatch(getLastLanguageOfFormStudent({ type: "student", studentId: user?.studentId })).then(
        async (resp) => await handleOnChangeSelect(resp?.lastDoneLanguage[0]?.lingoLanguageId ?? newPlan[0]),
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleOnChangeSelect = (value) => {
    setLingoLanguageId(value);
    handleGetStudentDashboard(value);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [plans]);

  return (
    <div className="countersInfoStudent">
      <div className="contentInfoStudent">
        <div className="cardCounter">
          <div className="lastSchedule">
            <div>
              <Select
                value={lingoLanguageId}
                input={<BootstrapInput />}
                id="demo-customized-select"
                onChange={(e) => handleOnChangeSelect(e.target.value)}
              >
                {allowedLanguage?.includes(1) && (
                  <MenuItem value={1}>
                    <FlagIcon size={30} code="US" />
                  </MenuItem>
                )}
                {allowedLanguage?.includes(2) && (
                  <MenuItem value={2}>
                    <FlagIcon size={30} code="ES" />
                  </MenuItem>
                )}
                {allowedLanguage?.includes(3) && (
                  <MenuItem value={3}>
                    <FlagIcon size={30} code="BR" />
                  </MenuItem>
                )}
                {allowedLanguage?.includes(4) && (
                  <MenuItem value={4}>
                    <FlagIcon size={30} code="FR" />
                  </MenuItem>
                )}
                {allowedLanguage?.includes(101) && (
                  <MenuItem value={101}>
                    <FlagIcon size={30} code="US" />
                  </MenuItem>
                )}
              </Select>
            </div>

            <div>
              <p className="titleLevel">{t("LEVEL")}</p>
              <span className="levelText">{currentStudentLevel}</span>
            </div>

            <div className="wrapperProgressBar">
              <span className="porcentProgressBar">{levelProgressPercents ?? 0}%</span>
              <div>
                <label className="levelDescription">{levelDescription[currentStudentLevel]}</label>
                <progress
                  max="100"
                  value={levelProgressPercents}
                  style={{ "--btn-color": rangeColorsLevel[currentStudentLevel] }}
                />
              </div>
            </div>

            {currentStudentCycle && (
              <div>
                <p className="titleInfo">{t("CYCLE")}</p>
                <div>
                  <span className={`cycle ${handleSelectColor(currentStudentLevel)}`}>{currentStudentCycle}</span>
                </div>
              </div>
            )}

            {studentDashboardHeader?.nextClass && (
              <div className="nextClass">
                <p>{t("UPCOMING_MATERIALS")}</p>
                <p className="blue_500">{studentDashboardHeader?.nextClass?.classTitle}</p>
                <p>{studentDashboardHeader?.nextClass?.cycleName}</p>
              </div>
            )}
          </div>
        </div>

        <div className="cardCounter" onClick={handleNavigateClassRating}>
          <img width={40} height={40} src={stopwatchPNG} className="stopwatch" alt="stopwatch png" />
          <span className="titleInfo pr_11">
            {ratingPending < 2 ? t("RATING_INFO_SINGULAR") : t("RATING_INFO_PLURAL")}
            <br />
            {ratingPending < 2 ? t("RATING_PENDING_INFO_SINGULAR") : t("RATING_PENDING_INFO_PLURAL")}
          </span>
          <span className="counterInfo">{ratingPending}</span>
        </div>
      </div>

      {isInterview && <img src={logoD4UPNG} alt="Logo D4U" className="logoPartner" />}
    </div>
  );
};

export default CardStudent;
